import React from 'react'
import styles from './AiReadinessHeader.module.css'
import Logo from "../../assets/landing_pageV1/coschoollogo.svg"
import Back from "../../assets/ai-readiness/back.svg"
import { useAiReadiness } from '../../context/AiReadinessContext.jsx'
import { useNavigate } from 'react-router-dom'

export default function AiReadinessHeader() {
    const { step, setStep, currentIndex, setCurrentIndex } = useAiReadiness();
    const navigate = useNavigate();
    const handleBack = () => {
        if (step == 2) {
            setStep(1);
            setCurrentIndex(6);
        } else if (step == 1) {
            if (currentIndex == 0) {
                setStep(0);
            } else {
                setCurrentIndex((prev) => Math.max(0, prev - 1));
            }
        }
    };
    return (
        <div className={styles.container}>
            <button className={styles.backButton} onClick={handleBack}>
                <img src={Back} alt="Back" className={styles.backIcon} />
            </button>
            <img src={Logo} alt="Coschool Logo" className={styles.logo}
                onClick={() => { navigate("/") }} />
        </div>
    )
}
